import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const objections = [{
  question: 'He intentado de todo.',
  answer: "Perfecto. Aquí no vienes a intentar. Vienes a ejecutar 5 minutos. El método está diseñado para funcionar incluso cuando ya has probado todo lo demás porque elimina la fricción de la 'gran meta'."
}, {
  question: 'Yo soy inconstante.',
  answer: 'No. Tú has practicado inconstancia. Y lo que se practica, se puede reentrenar. La identidad no es fija, es un hábito repetido.'
}, {
  question: 'No tengo tiempo.',
  answer: "Entonces este producto es exactamente para ti. Tu primera meta no es 'cambiar tu vida'. Es no hacer cero. Si no tienes 5 minutos, no tienes vida."
}, {
  question: '¿Y si fallo?',
  answer: 'Vas a fallar algún día. La diferencia es que aquí no se abandona: se reinicia. Te enseñamos el protocolo exacto para volver al camino sin culpa.'
}];
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-32 bg-[#0a1628] relative" data-id="element-191">
      <div className="max-w-3xl mx-auto px-5 md:px-6" data-id="element-192">
        <FadeIn data-id="element-193">
          <h2 className="text-2xl md:text-5xl text-white text-center mb-10 md:mb-16" data-id="element-194">
            Objeciones típicas{' '}
            <span className="text-[#64748b] block text-lg md:text-2xl mt-2 font-sans font-normal" data-id="element-195">
              (y respuesta honesta)
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-3 md:space-y-4" data-id="element-196">
          {objections.map((item, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-197">
              <div className={`border rounded-lg overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-[#d4af37] bg-[#1e3a5f]/20' : 'border-[#1e3a5f] bg-transparent'}`} data-id="element-198">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-6 text-left focus:outline-none" data-id="element-199">
                  <span className={`text-base md:text-xl font-medium pr-4 ${openIndex === index ? 'text-[#d4af37]' : 'text-white'}`} data-id="element-200">
                    {item.question}
                  </span>
                  {openIndex === index ? <Minus className="text-[#d4af37] flex-shrink-0 w-5 h-5" data-id="element-201" /> : <Plus className="text-gray-400 flex-shrink-0 w-5 h-5" data-id="element-202" />}
                </button>
                <AnimatePresence data-id="element-203">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-204">
                      <div className="p-4 md:p-6 pt-0 text-gray-300 text-sm md:text-base leading-relaxed border-t border-[#1e3a5f]/50 mt-2" data-id="element-205">
                        {item.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}